import { Link, Outlet, createFileRoute, useLocation } from '@tanstack/react-router';

import { cn } from '@/lib/utils';

// Layout de /remuneraciones — agrupa Liquidaciones y Previred como tabs.
// Misma estructura que /f29 (layout con tabs + Outlet).

export const Route = createFileRoute('/_app/remuneraciones')({
  component: RemuneracionesLayout,
});

interface Tab {
  readonly path: string;
  readonly label: string;
  readonly exact?: boolean;
}

const TABS: readonly Tab[] = [
  { path: '/remuneraciones', label: 'Liquidaciones', exact: true },
  { path: '/remuneraciones/previred', label: 'Previred' },
];

function RemuneracionesLayout() {
  const location = useLocation();
  return (
    <div className="flex flex-col">
      <nav
        className="flex items-center gap-1 border-b px-6 pt-4"
        style={{ borderColor: 'var(--color-border)' }}
        aria-label="Secciones de Remuneraciones"
      >
        {TABS.map((tab) => {
          const isActive = tab.exact
            ? location.pathname === tab.path
            : location.pathname.startsWith(tab.path);
          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={cn(
                '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-[color:var(--color-fg)] text-[color:var(--color-fg)]'
                  : 'border-transparent text-[color:var(--color-fg-muted)] hover:text-[color:var(--color-fg)]',
              )}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
